module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_7005.836e98d7.png";